import { Either, left, right } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import BucketEntity from "../../../../../domain/entities/BucketEntity";
import BucketDto from "../../../../dto/impl/BucketDto";
import di from "../../../../../di/DependencyInjection";
import UserHostApi, { UserHostApiName } from "../../../../settings/UserHostApi";

const GetAllBucketsApiImpl = async (): Promise<Either<ExceptionEntity, BucketEntity[]>> => {
    try {
        // Use /buckets/tree endpoint which returns hierarchy-filtered buckets with user counts
        const response = await di.get<UserHostApi>(UserHostApiName).get("/buckets/tree");
        const data = response.data ?? response;
        const buckets: BucketEntity[] = (Array.isArray(data) ? data : []).map((item: any) => BucketDto.fromJson(item));
        return right(buckets);
    } catch (error: any) {
        console.error("GetAllBucketsApiImpl error:", error);
        return left({ message: error?.message ?? "Error fetching buckets" });
    }
};

export default GetAllBucketsApiImpl;
